import { render, staticRenderFns } from "./AddDealer.vue?vue&type=template&id=ddaef6b6&scoped=true"
import script from "./AddDealer.vue?vue&type=script&lang=js"
export * from "./AddDealer.vue?vue&type=script&lang=js"
import style0 from "./AddDealer.vue?vue&type=style&index=0&id=ddaef6b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddaef6b6",
  null
  
)

export default component.exports